<template>
<section class="main__wrap">
  <div v-if="dialogRegisterVisible" class="register">
    <div class="register__body">
      <RegisterTutor @cancel="onDialogRegisterVisible()" />
    </div>
  </div> 
  <div v-if="dialogVisible" class="register">
    <div class="register__body">
        <ForgotPassword @cancel="onDialogRegisterVisible()"/>
    </div>
  </div>
<div class="body__wrap row">
  <LoginCarousel class="carousel col-sm-12 col-md-12 col-lg-7  mb-2 text-end"/>
  <div class="side col-sm-12 col-md-12 col-lg-5 align-self-center">
    <div class="wrap__login pb-1">
    <h1 class="wrap__login__title text-center pt-2" >Sign On</h1>
    <div v-loading="loading" class="wrap__login__form m-3">
      <template>
        <h2 class="text-center my-2 login-title">Who you are?</h2>
        <div class="wrap__btn">
          <div class="wrap__btn__parent mb-1"  @click="selectedRole = 2">
            <span>Parent</span>
          </div>
          <div class="wrap__btn__student"  @click="selectedRole = 1">
            <span>Student</span>
          </div>
        </div>
        <el-form class="wrap__input mb-2" ref="form" :model="form" :rules="rules">
          <el-form-item prop="username">
          <div class="wrap__input__username">
                <label>{{ $t('singup.username') }}</label>
                <el-input
                  v-model.trim="form.username"
                  type="text"
                  :placeholder="inputPlaceHolder"
                  :disabled="!seeControls"
                  @keyup.enter.native="onLogin"
                  @focusout.native="updateIsInputValidated">
                 </el-input>
          </div>
          </el-form-item>
          <el-form-item prop="password">
              <div class="wrap__input__password">
                <label>{{ $t('singup.password') }}</label>
                <div class="input-group">
                  <el-input v-model.trim="form.password" :type="typeElement" @keyup.enter.native="onLogin"
                  :disabled="!isEnableInputPass" ref='focusMe' v-on:change="checkValidateForm">
                  <el-button slot="append"  @click="onSeePassword"><i :class="[typeElement==='password' ? 'fa fa-eye':'fa fa-eye-slash']" aria-hidden="true"></i></el-button>
                  </el-input>
                </div>
            </div>
          </el-form-item>
           <small v-if="displayError" class="warning-notification d-block mb-2">
            {{ $t('login.pleaseCheck') }}
          </small>
        </el-form>
        <div class="wrap__sign" :class="seeControls">
          <button  class="text-white btn wrap__sign__btn mr-1" @click="onLogin" :disabled="!isButtonEnabled">
            Sign On
          </button>
          <hr class="wrap__sign__hr">  
        </div>
        <div class="d-flex justify-content-center align-items-center">
            <div class="d-flex justify-content-center flex-column text-center pb-1">
              <button class=" btn btn-link p-0" @click="dialogVisible = true">
                Forgot your password?
              </button>
            </div>
        </div>
      </template>
    </div>
  </div>
  <div class="wrap__register mt-3 mb-1">
    <span class="wrap__register__btn" @click="dialogRegisterVisible = true">
      Register new user
    </span>  
  </div>
  </div>         
</div>
<div class="img__bbb row">
  <div class="col-2"></div>
  <a class="img__bbb__link col-2" href="https://www.bbb.org/us/ca/downey/profile/computer-software-developers/home-media-products-llc-1216-100107486" target="_blank">
    <img class="img__bbb__link__img" src="@/assets/logo_bbb.svg" alt="Accredited business">
  </a>
</div>
</section> 
</template>
<script>
import { mapActions } from 'vuex';
import LoginCarousel from './components/LoginCarousel';
import ForgotPassword from './components/ForgotPassword';
import RegisterTutor from './../signup/tutor/index';

export default {
  name: 'Login',
  components: {
    ForgotPassword,
    RegisterTutor,
    LoginCarousel,
  },
  data() {
    return {
      username: '',
      password: '',
      displayError: false,
      loading: false,
      selectedRole: 0,
      forgotPW: false,
      isInstaller: false,
      dialogVisible: false,
      dialogRegisterVisible: false,
      inputPlaceHolder:'',
      typeElement:'password',
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '  ', trigger: 'blur' }],
        password: [{ required: true, message: '  ', trigger: 'blur'  }],
      },
      isEnableInputPass:false,
      isButtonEnabled:false,
    };
  },

  methods: {
    ...mapActions({
      login: 'auth/AUTH_REQUEST',
    }),
    onLogin() {
     this.username=this.form.username;
     this.password=this.form.password;
      this.loading = true;
      let selected_role = this.selectedRole;

      if (this.isInstaller) {
        selected_role = 3;
        // if selected role of practices
      } else if (this.selectedRole === 4) {
        selected_role = 1;
      }

      const { username, password } = this;
      this.login({ username, password, selected_role })
        .then(res => {
          // if selected role is practices
          if (this.selectedRole === 4) {
            // window.location.href = `http://state-exams.mytpm.org/tpmLogin/${res.data.access_token}`;
          } else {
            // this.$router.push({ name: 'home' });
            this.$router.push({ name: 'home', params: { access_token: res.data.access_token } });
          }
        })
        .catch(() => {
          this.displayError = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCloseDialogVisible() {
      this.dialogVisible = false;
    },
    onDialogRegisterVisible(e) {
      console.log('Ilmar', e);
      this.dialogRegisterVisible = false;
      this.dialogVisible=false;
    },
    onSeePassword(){
      // change type input for see password
      if(this.typeElement==='password'){
        this.typeElement='text';
      }else{
        this.typeElement='password';
      }
    },
    updateIsInputValidated(){
      this.$refs.form.validateField('username',(val2)=>{
        console.log(val2.length);
        if(val2.length===0){
          this.isEnableInputPass=true ;
          this.$nextTick(() => this.$refs.focusMe.focus())
        } else{
          this.isEnableInputPass=false;
        }
      })
    },
    checkValidateForm(){
          this.$refs['form'].validate((valid) => {
          if (valid) {
            console.log('submit!');
            this.isButtonEnabled=true;
          } else {
            console.log('error submit!!');
            this.isButtonEnabled=false;
          }
        });
    }
  },
  computed:{
    seeControls() {
      return  this.selectedRole>0 ? true:false
        // selectedRole=0 => unselected rol(user can't see inputs)
    }
  },
  watch:{
    selectedRole(val1,val2){
      //selectedRole=1 => Estudent; selectedRole=2 => Parent
      val1===2 ? this.inputPlaceHolder='Parent':this.inputPlaceHolder='Student'
    },
    isEnableInputPass(val){
      this.checkValidateForm();
    }
  },
};
</script>
<style lang="scss" scoped>
$color-fondo:#f3ad31;
$color-parent:#f3ad31;
$color-student:#73b243;
$color-btn-login:#DE6433;
$color-login:#3960a5;
$color-login-form:#ededed;
$border-radius:4rem;
@mixin css-buttons{
    line-height: 0.5rem;
    text-align: center;
    border-radius: $border-radius;
    max-width: 200px;
    margin: 0 auto;
    font-size: 1.1rem;
    padding: 15px 0 15px 0;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
}
@mixin box-shadow{
  box-shadow:  0.4rem 0.4rem 0.25rem rgba(0, 0, 0, 0.4);
}
.main__wrap{
  padding: 5px;
  @media all and (min-width:1000px ) {
    position: relative;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  &::before{
    content:url('~@/assets/TPM_yourpath.svg'); /* with class ModalCarrot ??*/
    position:absolute; /*or absolute*/
    z-index:1; /*a number that's more than the modal box*/
    left:10px;
    top:10px;
    width: 10rem;
    @media all and (max-width: 901px){
        content: '';
    }
    @media all and (min-width: 1921px){
           width: 18rem;
    }
  }
  .img__bbb{
    width: 100%;
    &__link{
      cursor: pointer;
       &__img{   
         @media all and (min-width: 1921px){
           width: 18rem;
         }
       }
    }
     @media all and (max-width: 901px){
      display: none;
    }
  }
}
.body__wrap{
  position: relative;
  background-color: $color-fondo;
  border-radius: $border-radius;
  .side{
    max-width: 500px;
    width: 100%;
    margin: 0 auto;
    @media all and (max-width:900px ) {
     max-width: 500px;
    }
    @media (min-width: 890px) and (max-width: 1401px){
      height: 450px;
     // overflow-y: scroll;
    }
  }
  .carousel{
    z-index: 0;
    overflow: hidden;
  }
  @media (min-width: 900px) and(max-width: 1000px) {
    margin: 0.5rem;
    padding: 0.5rem;
  }
  @media all and (min-width:1001px ) {
    width:75%;
    max-width: 1400px;
    margin: 1rem;
    padding: 1rem;
  }
  @media all and (min-width:2000px ) {
    width:80%;
    max-width: 2100px;
    padding: 2rem;
  }
}
.wrap__login{
   background-color: $color-login;
   border-radius: 3rem;
   @include box-shadow();
   &__title{
    color: white;
   }
   &__form{
    background-color: $color-login-form;
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
    overflow: hidden;
   }
}
.login-title{
  color: $color-login;
}
.wrap__btn{
  margin: 0 20px 0px 20px;
  color: white;
  &__parent{
    background-color:$color-parent;
    @include css-buttons();
  }
  &__student{
    background-color: $color-student;
    @include css-buttons();
  }
}
.wrap__input{
  max-width: 300px;
  margin: 0 auto;
  padding: 0 10px;
  &__username{
      color: $color-login;
      label{
       // padding-bottom: 5px;
      }
  }
  &__password{
    color: $color-login;
     label{
       // padding-bottom: 5px;
      }
    .input-group-prepend{
      box-shadow: 0.4rem 0.4rem 0.25rem rgba(0, 0, 0, 0.2);
    }
    .input-group-text{
      background-color: white;
      cursor: pointer;
      color: $color-login;
    }
  }
}

.form-control{
   box-shadow: 0.1rem 0.4rem 0.25rem rgba(0, 0, 0, 0.2);
    &:focus {
    border-color: #ced4da;
    outline: 0;
    box-shadow: none;
  }
}
.el-form-item{
  margin: 0;
}
.wrap__sign {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__btn{
    background: $color-btn-login;
    min-width: 200px;
    &:hover {
      opacity: 0.8;
    }
  }
  &__hr {
    width: 90%;
    border: 0;
    border-top: 3px solid #3960a5;
  }
}
.wrap__register{
  background-color: #3960a5;
  color: white;
  @include box-shadow();
  @include css-buttons();
  cursor: unset;
  &__btn{
    display: block;
    cursor: pointer;
  }
}
.register {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  overflow-y: scroll;
  z-index: 1;
  &__body {
    //background-color: #fff;
    margin-top: 8%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding-top: 1em;
    border-radius: 5px;
    @media all and (min-width:1001px ) {
      margin-top: 3%;
    }
  }
}
.warning-notification {
  color: #d50000;
  -webkit-tap-highlight-color: transparent;
  font: 400 12px Roboto, RobotoDraft, Helvetica, Arial, sans-serif;
  text-align: center;
}
.img-logo{
  position: absolute;
  top: 0;
  width: 10rem;
}
</style>
